import { jsx } from 'react/jsx-runtime';
import { cn } from '../../../lib/utils.js';

const LineIcon = ({
  type = "default",
  icoColor = "bg-icon-primary-01",
  icoName,
  className,
  onClick
}) => {
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn("ico-wrap", type, icoColor, icoName, className),
      "aria-hidden": "true",
      style: { backgroundColor: icoColor },
      onClick
    }
  );
};

export { LineIcon };
